import { RANK_CF_TYPE } from '@atlassian/jira-platform-field-config/src/index.tsx';
import type { BaseIssueNode } from '../list-cache/types.tsx';

export const getOptimisticRanked = (issue: BaseIssueNode, rank: string): BaseIssueNode => {
	const newRank = {
		...issue?.fields?.find(
			// eslint-disable-next-line @typescript-eslint/no-explicit-any
			(field: any) => field.type === RANK_CF_TYPE || field.aliasFieldId === 'rank',
		),
	};
	newRank.text = rank;
	return {
		...issue,
		fields: [
			...(issue?.fields?.filter(
				// eslint-disable-next-line @typescript-eslint/no-explicit-any
				(field: any) => field.type !== RANK_CF_TYPE && field.aliasFieldId !== 'rank',
			) || []),
			newRank,
		],
	};
};

export const getListViewRelativeIssueInfo = <
	IssueType extends {
		issueId: string;
		rank?: string | undefined;
		parentIssueId?: string;
	},
>({
	newIndex,
	oldIndex,
	issues,
	instruction,
	relativeIssueOverride,
}: {
	newIndex: number;
	oldIndex: number;
	issues: IssueType[];
	instruction?: string;
	relativeIssueOverride?: IssueType;
}) => {
	let rankCall = newIndex === 0 ? 'rankBefore' : 'rankAfter';

	// instruction will only be available ranking via dnd
	if (instruction) {
		rankCall = instruction === 'reorder-below' ? 'rankAfter' : 'rankBefore';
	}

	// if newIndex is 0 we want to optimistically rank it above the task that is
	// currently at index 0 of the collection
	let afterIndex = newIndex > oldIndex ? newIndex : Math.max(0, newIndex - 1);

	// newIndex will equal oldIndex in cases where we dnd to reparent and rank
	if (newIndex === oldIndex) {
		afterIndex = rankCall === 'rankAfter' ? Math.max(0, newIndex - 1) : newIndex;
	}

	let relativeIssue = relativeIssueOverride ?? issues[afterIndex];

	// if issue to rank after doesn't have a rank eg. group item then let's try and
	// rank before instead
	if (!relativeIssue?.rank) {
		const beforeIndex = newIndex > oldIndex ? Math.min(issues.length - 1, newIndex + 1) : newIndex;
		relativeIssue = issues[beforeIndex];
		rankCall = 'rankBefore';
	}

	return {
		rankCall,
		relativeIssue,
	};
};
